import {PhoneHQButton, PhoneHQGlyph, PhoneHQConfirmDialog} from 'ch3-ui-lib';
import {useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDeleteGroupMutation} from "../../store/features/groups/groupsService";

const DeleteGroupModal = () => {
    const {id} = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [deleteGroup, {isLoading}] = useDeleteGroupMutation();
    const [open, setOpen] = useState(false);

    const handleRemove = async () => {
        await deleteGroup(Number(id));
        setOpen(false);
        navigate("../admin/groups");
    };

    return (
        <>
            <PhoneHQButton variant="danger-secondary" onClick={() => setOpen(true)} phq-id='groupDetails-deleteGroupTriggerBtn'><PhoneHQGlyph name='delete' size={16}/>Delete this group</PhoneHQButton>
            <PhoneHQConfirmDialog
                open={open}
                onOpenChange={setOpen}
                title="Delete group"
                cancelLabel="Cancel"
                confirmLabel="Delete"
                tone="danger"
                busy={isLoading}
                onConfirm={handleRemove}
            >
                Are you sure you want to delete this group? This action cannot be undone.
            </PhoneHQConfirmDialog>
        </>
    );
};

export default DeleteGroupModal;
